const bookingPageSelector = [
  'body.booking-hide-chrome',
  'body.reservations',
  'body.montage-reservations',
  'body.booking',
].join(', ');

export default function () {
  if (!window.document.body.matches(bookingPageSelector)) {
    return;
  }

  const settings = window.azdsDefaultSettings || {};
  const loadingText = settings.bookingPreloaderEnabled ? settings.bookingPreloaderText || 'Please wait…' : '';

  function addPreloader(bookingLayout) {
    if (bookingLayout.querySelector('.azds-booking-section')) {
      return;
    }

    let container = bookingLayout.parentElement;
    if (!container.classList.contains('booking-layout-container')) {
      container = window.document.createElement('div');
      container.className = 'booking-layout-container';
      bookingLayout.before(container);
      container.append(bookingLayout);
    }

    if (container.querySelector(':scope > .booking-layout__preloader')) {
      return;
    }

    const preloader = window.document.createElement('div');
    preloader.className = 'booking-layout__preloader';
    preloader.setAttribute('role', 'status');
    preloader.textContent = loadingText;
    container.prepend(preloader);
  }

  window.document.querySelectorAll('booking-layout').forEach(addPreloader);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        if (node.matches('booking-layout')) {
          addPreloader(node);
        }

        node.querySelectorAll('booking-layout').forEach(addPreloader);
      });
    });
  });
  observer.observe(window.document.body, { childList: true, subtree: true });
}
